import SigviewAdminTableAws from "./SigviewAdminTable";
export default SigviewAdminTableAws;
